(function($) {

    class FrontpageAnimations {

        constructor() {

            /// Default duration for transitions
            this.duration = 0.5; // seconds
            
            /// The TimelineMax object for Sentiment section steps
            this.sentimentTimeline;

            //
            // General properties
            //
            shouldForceNav = false;
    
            //
            // jQuery objects
            //
            this.$window = $(window);
            this.$header = $('header.header');
            this.$masthead;
            this.$leverage;
            this.$sentiment;
            this.$sentimentWrapper;
            this.$outperform;
            this.$news;
            this.$footer;
            this.$backdrop1;
            this.$backdrop3;
            this.$scrollAnimationContainers = $('.scroll-animation-container');
            this.$paginationDots;
    
            //
            // Sentiment slides flags
            //
            this.sentimentStep = 0;
            this.ignoreScrollEvent = false;
            this.ignoreTimeout;

            this.initGeneral();
    
            this.splashAnimation(() => {
                $('section.splash').remove();
                var playPromise = $('#backdrop1-video')[0].play();
                if(playPromise !== undefined) {
                    playPromise.then(_ => {
                        console.log('playing');
                    }).catch(error => {
                        console.log(error, error.code, error.message, error.name);
                    })
                }
                this.initFullpageJS();
            });
        }
    
        checkVideoLoaded() {
            return $('#backdrop1-video')[0].readyState >= 2;
        }
    
        /// Initialize general stuff
        initGeneral() {
            const video = $('#backdrop1-video')[0];
            video.addEventListener('loadeddata', () => {
                if(video.readyState >= 2) {
                    video.pause();
                    video.currentTime = 0;
                }
            })
            $('.highlighting-text span').each(function() {
                $(this).html($(this).text().split('').map(function(c) { return $('<span>').html(c)}));
            });
            $('.scroll-animation-container').each(function() {
                $(this).find('.scroll-animation').each(function(animIndex) {
                    $(this).css('transition-delay', 0.3 * animIndex + 's');
                });
            });
            const $stepPs = $('.sentiment-steps .step p');
            function updateSentimentStepsHeight() {
                $stepPs.each(function(index) {
                    const $this = $($stepPs.eq(index));
                    $this.css({ height: $this.outerHeight() })
                });
            }
            updateSentimentStepsHeight();

            $('.pagination-dots a').on('click', () => {
                this.forceNavigation();
            });
            $('.footer')
                .remove()
                .appendTo('#frontpage-scenes')
                .addClass('fp-auto-height');
            
            const $ellipsizer = $('.ellipsizer');
            function updateEllipsizer() {
                $ellipsizer.ellipsizer();
            }
            updateEllipsizer();

            $(window).on('resize', function(){
                updateEllipsizer();
                updateSentimentStepsHeight();
            });
        }

        forceNavigation() {
            this.shouldForceNav = true;
            setTimeout(() => {
                this.shouldForceNav = false;
            }, 200);
        }
    
        splashAnimation(callback) {
            $('.backdrop1').css({ visibility: 'visible' });
            $('section.splash').addClass('active');
    
            let counter = 0;
    
            const tl = new TimelineMax({ paused: true, yoyo: true, repeat: -1 })
                .addLabel('start')
                .fromTo(
                    '.logo-parts .top',
                    3,
                    { y: -20 },
                    { y: 0, ease: Power2.easeInOut },
                )
                .fromTo(
                    '.logo-parts .right',
                    3,
                    { x: 20 },
                    { x: 0, ease: Power2.easeInOut },
                    '-=3',
                )
                .fromTo(
                    '.logo-parts .bottom',
                    3,
                    { y: 20 },
                    { y: 0, ease: Power2.easeInOut },
                    '-=3',
                )
                .fromTo(
                    '.logo-parts .left',
                    3,
                    { x: -20 },
                    { x: 0, ease: Power2.easeInOut },
                    '-=3',
                )
                .call(() => {
                    console.log('checking video...');
                    const videoReady = this.checkVideoLoaded();
                    console.log(videoReady);
                    if(videoReady || ++counter >= 2) {
                        tl.pause();
                        outro.play();
                    }
                })
                .addLabel('end');
    
            const outro = new TimelineMax( { paused: true } )
                .set('section.splash', { className: '-=active' })
                .set('header.header',  { className: '+=active' })
                .set('.frontpage-scenes-container', { className: '+=scrollable' }, '+=1')
                .addCallback(callback);
            
            tl.play();
        }
    
        setActivePaginationDot(index) {
            const $paginationDots = $('.pagination-dots li a');
            $paginationDots.removeClass('active');
            $('.pagination-dots li a.dot' + index).addClass('active');
        }
    
        initSentimentAnimation() {
            const appearStart = { y: 100, opacity: 0 };
            const appearEnd   = { y: 0,  opacity: 1 };
    
            const activate    = { className: '+=active' };
            const highlight   = { className: '+=highlighted' };
            const deactivate  = { className: '-=active' };
            const unlighlight = { className: '-=highlighted' };
            const clear       = { className: '-=highlighted active' };
    
            const resetH2 = { y: 100, scaleX: 1.2, scaleY: 1.2 };

            const typewriterDelay = 0.033;
            
            //
            // Sentiment
            //
            const h2 = document.querySelector('.scene.sentiment h2');
            const texts = document.querySelectorAll('.scene.sentiment .highlighting-text, .scene.sentiment .sentiment-steps');
            const steps = document.querySelectorAll('.sentiment-steps .step');
            const step1 = document.querySelector('.sentiment-steps .step1');
            const allStepsBut1 = document.querySelectorAll('.sentiment-steps .step:not(.step1)');
            const step2 = document.querySelector('.sentiment-steps .step2');
            const allStepsBut2 = document.querySelectorAll('.sentiment-steps .step:not(.step2)');
            const step3 = document.querySelector('.sentiment-steps .step3');
            const allStepsBut3 = document.querySelectorAll('.sentiment-steps .step:not(.step3)');
            const spans1 = document.querySelectorAll('.scene.sentiment .highlighting-text .highlight1 span');
            const spans2 = document.querySelectorAll('.scene.sentiment .highlighting-text .highlight2 span');
            const spans3 = document.querySelectorAll('.scene.sentiment .highlighting-text .highlight3 span');


            TweenMax.set(texts, appearStart);
            TweenMax.set(h2, resetH2);
            TweenMax.set(steps, deactivate);

            let cancelAutoPlay = false;
            let timer;
            const autoplay = (justMobile) => {
                clearAutoplay();
                if(cancelAutoPlay) { return; }
                timer = setTimeout(() => {
                    if(justMobile && $('.pagination-dots').is(':visible')) { return; }
                    this.sentimentTimeline.play();
                }, justMobile ? 3500 : 0);
            }

            const autoplayJustMobile = () => { autoplay(true); }

            const clearAutoplay = () => { clearTimeout(timer); }
            
            this.sentimentTimeline = new TimelineMax()
                .addLabel('start')
                .fromTo(
                    h2,
                    1,
                    resetH2,
                    { y: 0, scaleX: 1, scaleY: 1, ease: Power2.easeInOut },
                    '+=0.5'
                )
                .staggerFromTo(
                    texts,
                    this.duration,
                    appearStart,
                    appearEnd,
                    0.2
                )
                .set(this.$sentimentWrapper, { className: '+=empty-state transitioned' }, '-=0.25' )
                .call(autoplay)
                .addPause()
                .addLabel('step1')
                .call(() => { this.sentimentStep = 1 })
                .call(clearAutoplay)
                .set(allStepsBut1, clear )
                .set(step1, highlight )
                .staggerFromTo(
                    spans1,
                    0.05,
                    {color: '#D6D8E1'},
                    {color: '#2492D0'},
                    typewriterDelay,
                )
                .set(step1, activate, '-=0.75')
                .addLabel('step1end')
                .call(autoplayJustMobile)
                .addPause()
                .addLabel('step2')
                .call(() => { this.sentimentStep = 2 })
                .call(clearAutoplay)
                .set(allStepsBut2, clear)
                .set(step2, highlight, '+=0.25')
                .staggerFromTo(
                    spans2,
                    0.05,
                    { color: '#D6D8E1' },
                    { color: '#2492D0' },
                    typewriterDelay,
                    '+=0.5'
                )
                .set(step2, activate, '-=0.75')
                .addLabel('step2end')
                .call(autoplayJustMobile)
                .addPause()
                .addLabel('step3')
                .call(() => { this.sentimentStep = 3 })
                .call(clearAutoplay)
                .set(allStepsBut3, clear)
                .set(step3, highlight, '+=0.25')
                .staggerFromTo(
                    spans3,
                    0.05,
                    {color: '#D6D8E1'},
                    {color: '#2492D0'},
                    typewriterDelay,
                    '+=0.5'
                )
                .set(step3, activate, '-=0.75')
                .addPause()
                .addLabel('end');
            
            this.sentimentTimeline.reset = function() {
                cancelAutoPlay = false;
                this.sentimentStep = 0;
                this.sentimentTimeline.pause()
                    .seek('start')
                    .set(texts, appearStart)
                    .set(h2, resetH2)
                    .set(steps, deactivate)
                    .set(this.$sentimentWrapper, { className: '-=transitioned' } )
                    .set(this.$sentimentWrapper, { className: '+=empty-state' } )
            }.bind(this)

            this.sentimentTimeline.reset();
            
            $('.sentiment-steps .step h3').on('click', function(e){
                cancelAutoPlay = true;
                const $currentStep = $(e.target).closest('.step');
                if($currentStep.hasClass('step1')) {
                    this.sentimentTimeline.play('step1');
                }
                if($currentStep.hasClass('step2')) {
                    this.sentimentTimeline.play('step2');
                }
                if($currentStep.hasClass('step3')) {
                    this.sentimentTimeline.play('step3');
                }
            }.bind(this));
        }
    
        initJQueryObjects() {
            this.$masthead = $('.scene.masthead');
            this.$leverage = $('.scene.leverage');
            this.$sentiment = $('.scene.sentiment');
            this.$sentimentWrapper = $('.scene.sentiment .sentiment-wrapper');
            this.$outperform = $('.scene.outperform');
            this.$news = $('.scene.featured-news');
            this.$footer = $('footer.footer');
            this.$backdrop1 = $('.backdrop1');
            this.$backdrop3 = $('.backdrop3');
            this.$paginationDots = $('.pagination-dots');
        }
    
        afterScenesRendered() {
            if(!this.$masthead) { this.initJQueryObjects(); }
    
            $('.pagination-dots').addClass('active');
            this.$masthead.removeClass('cocooned');
            this.initSentimentAnimation();
        }
    
        afterSceneLoad(origin, destination, direction) {
            if(origin.anchor === destination.anchor) { return; }

            if(origin.anchor === 'anchor-sentiment') {
                this.sentimentTimeline.reset();
            }
    
            let $currentContainer;            
            switch(destination.anchor) {
                case 'anchor-masthead':
                    $currentContainer = this.$masthead;
                    this.$backdrop1.css({ visibility: 'visible' });
                    this.$backdrop3.css({ visibility: 'hidden' });
                    this.$header.addClass('white').removeClass('dark');
                    this.setActivePaginationDot(1);
                    break
                case 'anchor-leverage':
                    $currentContainer = this.$leverage;
                    this.$backdrop1.css({ visibility: 'visible' });
                    this.$backdrop3.css({ visibility: 'hidden' });
                    this.$header.addClass('white').removeClass('dark');
                    this.setActivePaginationDot(2);
                    break
                case 'anchor-sentiment':
                    $currentContainer = this.$sentiment;
                    this.$header.addClass('dark').removeClass('white');
                    this.sentimentTimeline.play('start');
                    this.setActivePaginationDot(3);
                    break
                case 'anchor-outperform':
                    $currentContainer = this.$outperform;
                    this.$backdrop1.css({ visibility: 'hidden' });
                    this.$backdrop3.css({ visibility: 'visible' });
                    this.$header.addClass('white').removeClass('dark');
                    this.setActivePaginationDot(4);
                    break
                case 'anchor-news':
                    $currentContainer = this.$news;
                    this.$header.addClass('dark').removeClass('white');
                    this.setActivePaginationDot(5);
                    break
                case 'anchor-footer':
                    this.$header.addClass('dark').removeClass('white');
                    break
            }
    
            // scroll transitions
            if(destination.anchor === 'anchor-news' && direction === 'up') { return true; }
            this.$scrollAnimationContainers.removeClass('animated-transition');
            setTimeout(() => {
                this.$scrollAnimationContainers.removeClass('in');
                if(origin.anchor === 'anchor-news' && direction === 'down') { this.$news.addClass('in'); }
                setTimeout(() => {
                    this.$scrollAnimationContainers.addClass('animated-transition');
                    $currentContainer && $currentContainer.addClass('in');
                }, 20);
            }, 300);
        }
    
        onSceneLeave(origin, destination, direction) {
            if(!this.$masthead) { this.initJQueryObjects(); }
            if(origin.anchor === destination.anchor) { return; }
            if(origin.anchor === 'anchor-sentiment') {
                let shouldAdvance = this.handleSentimentScroll(direction);
                if(!shouldAdvance) { return false; }
                setTimeout(() => {
                    this.sentimentTimeline.reset();
                }, 500);
            }
            if(origin.anchor === 'anchor-footer') {
                this.$header.removeClass('out');
                this.$paginationDots.addClass('active');
            }
            
            switch(destination.anchor) {
                case 'anchor-masthead':
                    this.$backdrop1.css({ visibility: 'visible' });
                    this.$backdrop3.css({ visibility: 'hidden' });
                    this.$header.addClass('white').removeClass('dark');
                    break
                case 'anchor-leverage':
                    this.$backdrop1.css({ visibility: 'visible' });
                    this.$backdrop3.css({ visibility: 'hidden' });
                    this.$header.addClass('white').removeClass('dark');
                    break
                case 'anchor-sentiment':
                    this.$header.addClass('dark').removeClass('white');
                    break
                case 'anchor-outperform':
                    this.$backdrop1.css({ visibility: 'hidden' });
                    this.$backdrop3.css({ visibility: 'visible' });
                    this.$header.addClass('white').removeClass('dark');
                    break
                case 'anchor-news':
                    this.$header.addClass('dark').removeClass('white');
                    break
                case 'anchor-footer':
                    this.$header.addClass('out');
                    this.$paginationDots.removeClass('active');
                    break
            }

            return true;
        }

        handleSentimentScroll(direction) {
            if(this.ignoreScrollEvent) { return false; }
            if(this.shouldForceNav) { return true; }
            let sentimentLabel;
            switch(direction) {
                case 'down':
                    if(this.sentimentStep >= 3) {
                        return true;
                    }
                    sentimentLabel = this.sentimentStep + 1;
                    break;
                case 'up':
                    if(this.sentimentStep <= 1) {
                        return true;
                    }
                    sentimentLabel = this.sentimentStep - 1;
                    break;
            }
            const label = `step${sentimentLabel}`;
            this.sentimentTimeline.play(label);
            clearTimeout(this.ignoreTimeout);
            this.ignoreScrollEvent = true;
            this.ignoreTimeout = setTimeout(() => {
                this.ignoreScrollEvent = false;
            }, 1000);
            return false;
        }
    
        initFullpageJS() {
            $('#frontpage-scenes').fullpage({
                licenseKey: '3210EF9E-4EB04745-AB9393AD-6B1F4975',
                dragAndMove: true,
                dragAndMoveKey: 'Y2F1c2FsaXR5bGluay5jb21fOTU0WkhKaFowRnVaRTF2ZG1VPWowMg==',
                slidesNavigation: true,
                sectionSelector: 'section, footer.footer',
                afterLoad: this.afterSceneLoad.bind(this),
                afterRender: this.afterScenesRendered.bind(this),
                onLeave: this.onSceneLeave.bind(this),
            });
        }
    }

    /// Wait for DOM ready and init everything
    $(document).ready(function() {
        
        if(!$('body.home').length) { return; } // Only run if this is front page

        new FrontpageAnimations();
    });

})(jQuery);